"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var EditSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M12.2036656,4.29901986 L14.5013389,6.63668405 C14.8859643,7.02800388 14.8834336,7.65616012 14.4956676,8.04436813 L7.70727364,14.8405 L4,14.8405 L4,11.1346473 L10.7803544,4.29592996 C11.1692016,3.90373573 11.8023607,3.9010224 12.194555,4.28986957 C12.1976115,4.29290003 12.2006484,4.29595019 12.2036656,4.29901986 Z M11.7862637,9.34184057 L9.4761235,7.03170035 L5,11.5463528 L5,13.8405 L7.29272636,13.8405 L11.7862637,9.34184057 Z M12.4929677,8.63433101 L13.7881581,7.33766424 L11.4904849,5.00000006 L10.1802001,6.32156334 L12.4929677,8.63433101 Z" })));
};
EditSmall.displayName = 'EditSmall';
exports.default = EditSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=EditSmall.js.map